import { Grid } from 'antd';

const { useBreakpoint } = Grid;

export { useBreakpoint };

export const useIsMobile = () => {
  const screens = useBreakpoint();
  return !screens.md;
};
